import { Message } from '@messageformat/react';
import { Button } from '@op/opds.opux';
import { IconUp } from '@op/opds.opux-icons/navigation';
import React, { RefObject } from 'react';

interface ReturnToTopProps {
  msgId: string;
  targetRef: RefObject<HTMLDivElement | null>;
  index: number;
}

const ReturnToTop = ({ index, msgId, targetRef }: ReturnToTopProps): JSX.Element => {
  const tabIds = [
    'first_tab',
    'second_tab',
    'third_tab',
    'fourth_tab',
    'fifth_tab',
    'sixth_tab',
    'seventh_tab',
    'eight_tab',
    'ninth_tab',
    'tenth_tab',
  ];

  const focusTabById = (id: string): void => {
    const tabElement = document.getElementById(id);
    if (tabElement) {
      tabElement.focus();
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
    event.preventDefault();

    if (targetRef.current) {
      const elementPosition =
        targetRef.current.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth',
      });
      focusTabById(tabIds[index]);
    }
  };

  return (
    <div
      style={{
        marginTop: '4rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Button icon={IconUp} onClick={handleClick}>
        <Message id={msgId} />
      </Button>
    </div>
  );
};

export default ReturnToTop;
